import { SxStyles } from 'types/styles';
import { basicTheme } from 'theme';
export const styles: SxStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  },
  placeholder: {
    color: basicTheme.palette.mainPalette.mult50,
  },
  root: {
    height: 40,
    maxHeight: 40,
    width: '100%',
    borderRadius: 1,
    color: basicTheme.palette.mainPalette.dark,
    cursor: 'pointer',
    '& .MuiOutlinedInput-input': {
      padding: 0,
      px: 3,
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      cursor: 'pointer',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: basicTheme.palette.mainPalette.disabled,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: basicTheme.palette.mainPalette.mult50,
      borderWidth: '1px',
    },
    '&.Mui-error .MuiOutlinedInput-notchedOutline': {
      borderColor: basicTheme.palette.systemPalette.red,
    },
    '&& .MuiSvgIcon-root': {
      color: basicTheme.palette.mainPalette.primary,
      top: 10,
      width: 20,
      height: 20,
      opacity: 1,
    },
    '& .MuiSelect-select': {},
  },

  error: {
    '&& .MuiOutlinedInput-notchedOutline': {
      borderColor: basicTheme.palette.systemPalette.red,
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: basicTheme.palette.systemPalette.red,
      borderWidth: '1px',
    },
  },
  errorText: {
    color: basicTheme.palette.systemPalette.red,
    ml: 3,
    mt: 1,
  },

  rotateIcon: {
    '& .MuiSelect-icon': {
      transform: 'none !important',
    },
  },
  paper: {
    mt: 2,
    p: 2,
    br: 2,
    border: '1px solid',
    borderRadius: 2,
    borderColor: 'mainPalette.thirdGrey',
    overflow: 'visible',
    display: 'flex',
    flexDirection: 'column',
    boxShadow: '0px 16px 32px 0px rgba(19, 17, 38, 0.10)',
    minWidth: '240px',
  },

  menuItem: {
    mb: 1,
    minWidth: 'max-content',
    borderRadius: 2,
    color: basicTheme.palette.mainPalette.dark,
    display: 'flex',
    alignItems: 'center',
    gap: 2,
    justifyContent: 'space-between',
    '&:hover': {
      backgroundColor: basicTheme.palette.mainPalette.lightSecondaryGrey,
    },
    '&.Mui-selected': {
      backgroundColor: basicTheme.palette.mainPalette.lightSecondaryGrey,
      '&:hover': {
        backgroundColor: basicTheme.palette.mainPalette.lightSecondaryGrey,
      },
    },
  },
};
